import { Routes } from '@angular/router';
import { authGuard, loginGuard } from '@core/guards';
import { firebaseConfigResolver } from '@shared/services';

import { MAIN_ROUTES } from '@core/pages/main-layout/main-layout.routes';
import { mapLoaderResolver } from '@shared/services/map-loader.resolver';
import { initializeApp, provideFirebaseApp } from '@angular/fire/app';
import { getFirestore, provideFirestore } from '@angular/fire/firestore';
import { getStorage, provideStorage } from '@angular/fire/storage';
import { getAuth, provideAuth } from '@angular/fire/auth';
import { environment } from '@envs/environment';
import { GlobalService } from '@core/services';
import { VideoUploadService } from '@shared/services/video-upload.service';

export const routes: Routes = [
  {
    path: 'authentication/login',
    loadComponent: () =>
      import('./core/pages/auth/login/login.component').then(
        m => m.LoginComponent
      ),
    canActivate: [loginGuard],
  },
  {
    path: 'authentication/login/callback',
    loadComponent: () =>
      import('./core/pages/auth/login/login.component').then(
        m => m.LoginComponent
      ),
  },
  {
    path: '',
    loadComponent: () =>
      import('@core/pages/main-layout/main-layout-wrapper.component').then(
        m => m.MainLayoutWrapperComponent
      ),
    resolve: { maps: mapLoaderResolver, firebase: firebaseConfigResolver },
    canActivate: [authGuard],
    providers: [
      provideFirebaseApp(injector => {
        const globalService = injector.get(GlobalService);
        return initializeApp({
          ...environment.firebaseConfig,
          apiKey: globalService.firebaseApiKey(),
        });
      }),
      provideAuth(() => getAuth()),
      provideFirestore(() => getFirestore()),
      provideStorage(() => getStorage()),
      VideoUploadService,
    ],
    children: [...MAIN_ROUTES],
  },
  {
    path: '**',
    redirectTo: '404',
    pathMatch: 'full',
  },
];
